import { cn } from "@/lib/utils/tw";
import { ArrowRight } from "lucide-react";

interface AnimatedArrowProps {
  className?: string;
}

export const AnimatedArrow = ({ className }: AnimatedArrowProps) => {
  return (
    <div className={cn("relative h-4 w-4 overflow-hidden", className)}>
      <div className="absolute inset-0 flex items-center justify-center">
        {/* First arrow (hidden by default) */}
        <ArrowRight className="absolute h-4 w-4 translate-x-0 transition-all duration-300 ease-out group-hover:translate-x-4" />
        {/* Second arrow (visible by default) */}
        <ArrowRight className="absolute h-4 w-4 -translate-x-4 transition-all duration-300 ease-out group-hover:translate-x-0" />
      </div>
    </div>
  );
};
